export default __webpack_public_path__ + "static/media/c3.aca0c042.jpeg";